import React, { Component } from 'react';

import ConfiguracionBasicaActiveDirectory from "./ConfiguracionBasicaActiveDirectory";
import ModeActiveDirectory from "./ModeActiveDirectory";

const DetalleConfiguracionActiveDirectory = (props) => {
    return (
        <div className="row">

            <div className="left-separator-xs panel panel-view">
                <div>
                    <label>
                        <i className="ti-microsoft-alt  panel-view-icon" />
                        <p>Active Directory</p>
                        <span>Administra usuarios, perfiles y permisos contemplando el directorio de usuarios y grupos de Windows.</span>
                    </label>
                </div>
            </div>

            <div className="col-xs-12 left-separator-xs">
                <ConfiguracionBasicaActiveDirectory
                    maxDiasInactividad={props.maxDiasInactividad}
                    minutosPermitidosInactividad={props.minutosPermitidosInactividad}/>
            </div>

            <div className="col-xs-12 left-separator-xs">
                <ModeActiveDirectory
                    vincularGrupoWindows={props.vincularGrupoWindows}
                    altaAutomatica={props.altaAutomatica}
                    soloUsuarioLoggeado={props.soloUsuarioLoggeado}
                    solicitarContrasenia={props.solicitarContrasenia}/>
            </div>
        </div>
    );
};

export default DetalleConfiguracionActiveDirectory;


